import styled from "styled-components";

import { type IStyledAttributes } from "@ryde/shared";
import { blueMui, MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";

export const TableLoadingIndicatorStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "table-loading-indicator",
})`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  background-color: ${rydeColors.smoke};
`;

export const TableWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "table-wrapper",
})`
  min-width: 100%;
  padding-inline-start: 20px;
  padding-inline-end: 4px;
  padding-top: 15px;
  padding-bottom: 10px;
  position: relative;

  // Additions styles
  .ride-start-end-date-editable-template {
    display: flex;
    align-items: center;
  }
  .ride-start-end-date-editable-template--hidden {
    .ride-start-end-date-editable-template__date {
      visibility: hidden;
    }
  }
  .ride-start-end-date-editable-template__date {
    font-size: 14px;
    border: 1px solid ${blueMui._300};
    padding-inline-start: 5px;
    padding-inline-end: 14px;
    padding-block: 5px;
    text-align: right /*@noflip*/;
    direction: ltr /*@noflip*/;
    width: 150px;
    height: 30px;
    color: rgba(0, 0, 0, 0.87); // TODO move to variable
  }
  // Wide enough for the AM/PM suffix, which the 150px box cuts off.
  .ride-start-end-date-editable-template--ampm
    .ride-start-end-date-editable-template__date {
    width: 190px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-inline-start: 0;
  }
`;
